module.exports = __webpack_public_path__ + "static/media/3BOX-102-badge.a1d423b4.svg";